import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { langCheck, getAvatarName } from 'Pub/js/utils.js';
import { getStore, setStore } from "Pub/js/storageUtils";
import Ajax from 'Pub/js/ajax';
import platform from 'Pub/js/platform';
import AvatarList from './AvatarList';
const { NCDiv } = platform.base;
const { promptBox } = platform;
import AvatarImg from "Components/AvatarImg";

class InfoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            canEdit: false, //修改按钮是否可编辑
            showAvatarList: false // 是否显示头像列表
        };
    }

    componentDidMount() {
        this.checkBtnAuth();
    }
    handleClick = infoType => {
        this.props.infoSetting(infoType);
    };

    //解除绑定云账号
    handleUnbind = () => {
        promptBox({
            color: 'warning',
            content: langCheck(
                'UserInfo-000046',
                'pages',
                this.props.json
            ) /* 国际化处理： 此操作会解除原绑定账户信息，确定要继续吗？*/,
            beSureBtnClick: () => {
                Ajax({
                    toastContainer: this.props.pageRef,
                    url: `/nccloud/baseapp/yht/ubind.do`,
                    info: {
                        name: langCheck(
                            'UserInfo-000000',
                            'pages',
                            this.props.json
                        ) /* 国际化处理： 账户设置*/,
                        action: langCheck(
                            'UserInfo-000045',
                            'pages',
                            this.props.json
                        ) /* 国际化处理： 解除绑定云账号*/,
                    },
                    success: ({ data: { data } }) => {
                        window.logout();
                    },
                });
            },
        });
    };

    //查询系统参数判断是否可以修改个人信息
    checkBtnAuth = () => {
        Ajax({
            toastContainer: this.props.pageRef,
            url: `/nccloud/platform/userinfo/checkhaspsninfo.do`,
            info: {
                name: langCheck(
                    'UserInfo-000000',
                    'pages',
                    this.props.json
                ) /* 国际化处理： 账户设置*/,
                action: langCheck(
                    'UserInfo-000054',
                    'pages',
                    this.props.json
                ) /* 国际化处理： 查询系统参数*/,
            },
            sysAppcode: 10228888,
            success: ({ data: { data } }) => {
                this.setState({ canEdit: data && data.canEdit });
            },
        });
    }

    //邮箱
    renderEmail = ({ email, type, canEdit = true } = {}) => {
        const { json } = this.props;
        return (
            <React.Fragment>
                <div className="item border-bottom">
                    <label className="label">
                        {langCheck('UserInfo-000026', 'pages', json) /* 国际化处理： 邮箱*/}
                    </label>
                    <div className="item-content">
                        {email && email.length > 0 ? (
                            <span>{email}</span>
                        ) : (
                            <span className="not-setting">
                                {langCheck(
                                    'UserInfo-000027',
                                    'pages',
                                    json
                                ) /* 国际化处理： 未设置*/}
                                <i className="iconfont icon-jinggao" />
                            </span>
                        )}
                        {canEdit && (
                            <span
                                className="btn nc-theme-link-font-c"
                                onClick={() => {
                                    const infoType = type === 'personal' ? '3' : '2';
                                    this.handleClick(infoType);
                                }}
                            >
                                {email && email.length > 0
                                    ? langCheck('UserInfo-000047', 'pages', json) /* 国际化处理： 更换邮箱*/
                                    : langCheck(
                                        'UserInfo-000028',
                                        'pages',
                                        json
                                    ) /* 国际化处理： 修改,绑定邮箱*/}
                            </span>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    };
    //手机号
    renderPhone = (phone, canEdit = true) => {
        const { json, is_cloud_register } = this.props;
        return (
            <React.Fragment>
                <div className="item border-bottom">
                    <label className="label">
                        {langCheck('UserInfo-000029', 'pages', json) /* 国际化处理： 邮箱*/}
                    </label>
                    <div className="item-content">
                        {phone && phone.length > 0 ? (
                            <span>{phone}</span>
                        ) : (
                            <span className="not-setting">
                                {langCheck(
                                    'UserInfo-000027',
                                    'pages',
                                    json
                                ) /* 国际化处理： 未设置*/}
                                <i className="iconfont icon-jinggao" />
                            </span>
                        )}
                        {is_cloud_register && canEdit && (
                            <span
                                className="btn nc-theme-link-font-c"
                                onClick={() => {
                                    this.handleClick('4'); //0是密码弹窗，1是手机弹窗，2和3是邮箱弹窗，4也是手机弹窗，UI不同于1
                                }}
                            >
                                {phone && phone.length > 0
                                    ? langCheck('UserInfo-000016', 'pages', json) /* 国际化处理： 更换手机号*/
                                    : langCheck(
                                        'UserInfo-000025',
                                        'pages',
                                        json
                                    ) /* 国际化处理： 修改,绑定手机号*/}
                            </span>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    };

    //人员信息
    renderPersonelInfo = () => {
        const { json, is_cloud_register, personelInfo } = this.props;
        const { name, email, mobile } = personelInfo || {};
        return (
            <React.Fragment>
                <div className="title info margin-bottom-12 margin-top-50">
                    {langCheck('UserInfo-000044', 'pages', json) /* 国际化处理： 人员信息*/}
                </div>
                <div className="item border-bottom">
                    <label className="label">
                        {langCheck('UserInfo-000022', 'pages', json) /* 国际化处理： 姓名*/}
                    </label>
                    <div className="item-content">
                        <span>{name}</span>
                    </div>
                </div>
                <div className="item border-bottom">
                    <label className="label">
                        {langCheck('UserInfo-000029', 'pages', json) /* 国际化处理： 手机号码*/}
                    </label>
                    <div className="item-content">
                        {mobile && mobile.length > 0 ? (
                            <span>{mobile}</span>
                        ) : (
                            <span className="not-setting nc-theme-link-font-c">
                                {langCheck(
                                    'UserInfo-000027',
                                    'pages',
                                    json
                                ) /* 国际化处理： 未设置*/}
                                <i className="iconfont icon-jinggao" />
                            </span>
                        )}
                        {/* 云注册环境可以修改手机号 */}
                        {is_cloud_register && this.state.canEdit && (
                            <span
                                className="btn nc-theme-link-font-c"
                                onClick={() => {
                                    this.handleClick('1');
                                }}
                            >
                                {mobile && mobile.length > 0
                                    ? langCheck('UserInfo-000048', 'pages', json) /* 国际化处理： 更换手机号*/
                                    : langCheck(
                                        'UserInfo-000025',
                                        'pages',
                                        json
                                    ) /* 国际化处理： 绑定手机号*/}
                            </span>
                        )}
                    </div>
                </div>
                {/* 人员邮箱通过参数控制 */}
                {this.renderEmail({ email, type: 'personal', canEdit: this.state.canEdit })}
            </React.Fragment>
        );
    };

    render() {
        let { userName, email, phone, json, userCode, is_cloud_register, avatar, deployType } = this.props;
        const { showAvatarList } = this.state;
        let STOREFORINFODATA = getStore("STOREFORINFODATA");

        let telphone = phone || STOREFORINFODATA.telphone
        return (
            <div className="userinfo-container">
                <NCDiv className="userinfo-content" fieldid="userinfo" areaCode={NCDiv.config.Area}>
                    <div className="title info margin-bottom-12 margin-top-50">
                        {langCheck('UserInfo-000023', 'pages', json) /* 国际化处理： 账号信息*/}
                    </div>
                    <div className="item border-bottom picture">
                        <label className="label">
                            {langCheck('UserInfo-000021', 'pages', json) /* 国际化处理： 头像*/}
                        </label>
                        <div className="item-content">
                            <div className="userlogo" onClick={() => { this.setState({ showAvatarList: true }) }}>
                                <AvatarImg imgUrl={avatar} />
                                <i className="iconfont icon-xiugaigerenxinxi" />
                            </div>
                        </div>
                    </div>
                    <div className="item border-bottom">
                        <label className="label">
                            {langCheck('UserInfo-000043', 'pages', json) /* 国际化处理： 用户名*/}
                        </label>
                        <div className="item-content">
                            <span>{userName}</span>
                        </div>
                    </div>
                    <div className="item border-bottom">
                        <label className="label">
                            {langCheck('UserInfo-000042', 'pages', json) /* 国际化处理： 账号*/}
                        </label>
                        <div className="item-content">
                            <span>{userCode}</span>
                        </div>
                    </div>
                    {this.renderEmail({ email })}
                    <div className="item border-bottom pw">
                        <label className="label">
                            {langCheck('UserInfo-000007', 'pages', json) /* 国际化处理： 密码*/}
                        </label>
                        <div className="item-content">
                            <span>******</span>
                            <span
                                className="btn nc-theme-link-font-c"
                                onClick={() => {
                                    this.handleClick('0');
                                }}
                            >
                                {langCheck(
                                    'UserInfo-000024',
                                    'pages',
                                    json
                                ) /* 国际化处理： 修改*/}
                            </span>
                        </div>
                    </div>
                    {this.renderPhone(telphone)}
                    {this.props.personelInfo && this.renderPersonelInfo()}
                    {is_cloud_register && deployType === 'cloud' && (
                        <div className="item">
                            <div className="item-content">
                                <span className="btn nc-theme-link-font-c" onClick={this.handleUnbind}>
                                    {langCheck(
                                        'UserInfo-000045',
                                        'pages',
                                        json
                                    ) /* 国际化处理： 解除绑定云账号*/}
                                </span>
                            </div>
                        </div>
                    )}
                    {
                        showAvatarList && <AvatarList
                            pageRef={this.props.pageRef}
                            json={json}
                            closeAvatarList={() => { this.setState({ showAvatarList: false }) }}
                        />
                    }
                </NCDiv>
            </div>
        );
    }
}
InfoForm.propTypes = {
    userName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
};
export default connect(
    state => ({
        userName: state.appData.userName,
        avatar: state.appData.avatar,
        email: state.appData.email,
        phone: state.appData.phone,
        userCode: state.appData.userCode,
        is_cloud_register: state.appData.is_cloud_register,
        deployType: state.appData.deployType
    }),
    {}
)(InfoForm);
